import { createSelector } from "reselect";

import {
  PersonalSettingsSpacesTableGroupMeta,
  PersonalSettingsSpacesTableGroupsStore,
} from "./types";
import { SpaceActionsGroup } from "../../types";
import { isSpaceActionsGroup } from "../helpers";

export const selectGroupsMeta = createSelector(
  (state: PersonalSettingsSpacesTableGroupsStore, groupId: string) => state.groupsMeta[groupId],
  (result): PersonalSettingsSpacesTableGroupMeta | undefined => result
);

const selectOpenGroups = createSelector(
  (state: PersonalSettingsSpacesTableGroupsStore) => state.groupsMeta,
  (groupsMeta): string[] => {
    return Object.keys(groupsMeta).filter((groupId) => groupsMeta[groupId].isOpen);
  }
);

export const selectStickyRanges = createSelector(
  selectOpenGroups,
  (state: PersonalSettingsSpacesTableGroupsStore) => state.groups,
  (openGroups, groups): [string, string][] => {
    return openGroups.reduce<[string, string][]>((acc, groupId) => {
      const item = groups.find((group) =>
        isSpaceActionsGroup(group) ? group.spaceID === groupId : null
      ) as SpaceActionsGroup;

      const itemsIds = item?.actions || [];

      if (itemsIds) {
        const lastItem = itemsIds[itemsIds.length - 1];

        acc.push([groupId, lastItem.id]);
      }
      return acc;
    }, []);
  }
);
